var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "audio-container read-only",
      attrs: {
        "data-url": _vm.url,
        "data-attachmentId": _vm.attachmentId,
        "data-duration": _vm.duration,
        "data-text": _vm.text,
        "data-filename": _vm.filename,
        "data-description": _vm.description,
        id: _vm.attachmentId,
      },
      on: { mousedown: _vm.mousedownHandler },
    },
    [
      _c("audio", {
        ref: "audio",
        staticStyle: { "{ display": "'none' }" },
        attrs: {
          src: _vm.url,
          controlslist: "nodownload nofullscreen noremoteplayback",
          disablePictureInPicture: "",
        },
        on: {
          play: _vm.onPlay,
          pause: _vm.onPause,
          ended: _vm.onStop,
          waiting: _vm.onLoading,
          canplay: _vm.onCanPlay,
          timeupdate: _vm.onTimeUpdate,
          loadedmetadata: _vm.onLoadedMeteData,
        },
      }),
      _vm._v(" "),
      _c("section", { staticClass: "audio-player-controls" }, [
        _c("section", { staticClass: "btn", on: { click: _vm.handleClick } }, [
          _vm.status === "stop"
            ? _c("span", [_c("svg-icon", { attrs: { name: "play_audio" } })], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.status === "play"
            ? _c(
                "span",
                [_c("svg-icon", { attrs: { name: "pause_audio" } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.status === "loading"
            ? _c(
                "span",
                [_c("svg-icon", { attrs: { name: "loading_audio" } })],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "currentTime" }, [
          _vm._v(_vm._s(_vm.formatTime)),
        ]),
        _vm._v(" "),
        _c(
          "section",
          {
            ref: "seek",
            staticClass: "seek-bar-back",
            on: { touchstart: _vm.onDragStart, mousedown: _vm.onDragStart },
          },
          [
            _c("section", {
              staticClass: "seek-bar-progress",
              style: {
                transform:
                  "scaleX(" + _vm.currentTime / _vm.computedDuration + ")",
              },
            }),
            _vm._v(" "),
            _c("section", {
              class:
                "seek-bar-progress-btn " +
                (_vm.isDraggingProgress ? "is-drag" : ""),
              style: {
                left:
                  ((_vm.currentTime / _vm.computedDuration) * 100).toFixed(0) +
                  "%",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("section", { staticClass: "duration" }, [
          _vm._v(_vm._s(_vm.formatDuration)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !!_vm.text,
              expression: "!!text",
            },
          ],
          staticClass: "audio-transfer-text",
        },
        [
          _c("p", { staticClass: "transfer-text-label" }, [
            _vm._v("以下内容为语音转文字，不保证准确，仅供参考"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "audio-text", style: _vm.collapsesStyle }, [
            _c("p", { ref: "innerWrap", staticClass: "inner-text" }, [
              _vm._v(_vm._s(_vm.text)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "collapse-btn", style: _vm.collapsesBtnStyle },
              [
                _c(
                  "div",
                  { on: { click: _vm.handleToggle } },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.collapsesOpen ? "收起" : "展开")),
                    ]),
                    _vm._v(" "),
                    _c("svg-icon", {
                      staticClass: "arrow",
                      class: _vm.collapsesOpen ? "active" : "",
                      attrs: { name: "arrow" },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }